import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../types";
import { Chat } from "../chat-slice";

export const handleNewResponseComplete = createAsyncThunk<
  // Return type of the payload creator
  Chat,
  // First argument to the payload creator
  {turnId: string}
  // Types for ThunkAPI,
>('chat-slice/handle-new-response-complete',
  async ({ turnId }, { getState, fulfillWithValue, rejectWithValue }) => {
    const state = getState() as RootState;

    const chatSliceStateCopy = structuredClone(state.chat);

    if (!chatSliceStateCopy.streamingMessageTurnId || chatSliceStateCopy.streamingMessageTurnId !== turnId) {
      return rejectWithValue(chatSliceStateCopy);
    }

    const currentIsDoneAnimationBuffer = chatSliceStateCopy.isDoneAnimationBuffer;

    if (!chatSliceStateCopy.buffer) {
      chatSliceStateCopy.isDoneAnimationBuffer = true;
    }

    if (currentIsDoneAnimationBuffer && chatSliceStateCopy.buffer) {
      chatSliceStateCopy.messages.push({
        itemType: "A",
        value: chatSliceStateCopy.buffer,
        turn_id: chatSliceStateCopy.streamingMessageTurnId,
        conversation_id: state["app-state"].conversationId
      });
      chatSliceStateCopy.buffer = '';
      delete chatSliceStateCopy.streamingMessageTurnId;
    }

    chatSliceStateCopy.isStreamingHandling = false;

    return fulfillWithValue(chatSliceStateCopy);
  }
)